import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-278d2d91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quality-wrap" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { style: {"color":"#fa660a"} }
const _hoisted_5 = { class: "bottom" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "责任人：", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "对象类型：", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开始时间：", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "完成期限：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_sticky, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_search, {
          modelValue: _ctx.searchForm.search_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.search_name) = $event)),
          shape: "round",
          placeholder: "搜索",
          onBlur: _ctx.onSearch
        }, null, 8, ["modelValue", "onBlur"]),
        _createVNode(_component_van_dropdown_menu, {
          "active-color": "#3d6eeb",
          "close-on-click-outside": false,
          class: "quality-dropdown"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_dropdown_item, {
              title: _ctx.getTitle(_ctx.searchForm.target_type.option, _ctx.searchForm.target_type.value, '对象类型'),
              modelValue: _ctx.searchForm.target_type.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.target_type.value) = $event)),
              options: _ctx.searchForm.target_type.option,
              onChange: _ctx.onChange
            }, null, 8, ["title", "modelValue", "options", "onChange"]),
            _createVNode(_component_van_dropdown_item, {
              title: _ctx.getTitle(_ctx.searchForm.recheck_type.option, _ctx.searchForm.recheck_type.value, '当前检查'),
              modelValue: _ctx.searchForm.recheck_type.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.recheck_type.value) = $event)),
              options: _ctx.searchForm.recheck_type.option,
              onChange: _ctx.onChange
            }, null, 8, ["title", "modelValue", "options", "onChange"]),
            _createVNode(_component_van_dropdown_item, {
              title: _ctx.getTitle(_ctx.searchForm.state.option, _ctx.searchForm.state.value, '当前状态'),
              modelValue: _ctx.searchForm.state.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.state.value) = $event)),
              options: _ctx.searchForm.state.option,
              onChange: _ctx.onChange
            }, null, 8, ["title", "modelValue", "options", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.pageData.list.length)
      ? (_openBlock(), _createBlock(_component_van_list, {
          key: 0,
          loading: _ctx.pageData.loading,
          "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageData.loading) = $event)),
          finished: _ctx.pageData.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad,
          class: "quality-list"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData.list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "quality-list-item",
                key: item.id,
                onClick: ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.QUALITY_ABOUT_DETAIL,
            query: { id: item.id, recheck_num: item.recheck_num }
          })
        )
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, "检查单号：" + _toDisplayString(item.orderid), 1),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(item.recheck_num_name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.obj_name), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.pool_name), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(_toDisplayString(item.liable_user_info.name || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(item.target_type_name || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createTextVNode(_toDisplayString(item.start_time_name || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(_toDisplayString(item.end_time_name || "-"), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(['state', `state${item.state}`])
                }, _toDisplayString(item.state_name), 3)
              ], 8, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"]))
      : (_openBlock(), _createBlock(_component_van_empty, {
          key: 1,
          class: "empty-image",
          image: require('../../assets/empty@2x.png'),
          description: "暂无数据"
        }, null, 8, ["image"]))
  ]))
}